import { createAxiosInstance } from '../api/api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { onSuccess, Method, MutationObject, Config, Body } from './shared';

const createFormDataMutation = (method: Method) => <T>(config: Config = {}): UseMutationResult<T, Error, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation<T, Error, any, unknown>(async (data: MutationObject | Body):  Promise<T> => {
    const path = typeof data?.path === 'string' ? data.path : config.path;
    const payload = typeof data?.path === 'string' ? data.body : data;
    const axios = createAxiosInstance();
    axios.interceptors.request.use(axiosConfig => {
      return {
        ...axiosConfig,
        onUploadProgress: (event: ProgressEvent): void => {
          config.onUploadProgress?.(event);
        }
      };
    });
    const result = await axios[method](path as string, createFormData(payload), { headers: { 'Content-Type': 'multipart/form-data' } });
    return result.data as T;
  }, {
    onSuccess: onSuccess.bind(null, queryClient, config)
  });
};

export const usePostFormDataMutation = createFormDataMutation(Method.POST);
export const usePutFormDataMutation = createFormDataMutation(Method.PUT);

const createFormData = (payload: any): FormData => {
  const formData = new FormData();
  for (const key in payload) {
    if (key === 'id' || !payload[key]) {
      continue;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    formData.append(key, payload[key]?.toString?.()?.toLowerCase().includes('filelist') ? payload[key][0] : payload[key]);
  }
  return formData;
};
